<mat-autocomplete
  #auto="matAutocomplete"
  #matAutoComplete
  autoActiveFirstOption
  (optionSelected)="selectOption($event)"
  [displayWith]="displayWithOptionLabel"
>
  @for (result of searchResults$ | async; track result) {
  <mat-option [value]="result" [matTooltip]="result.label" matTooltipPosition="after" multiLineOption>
    @if (templateRef) {
    <div>
      <ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{ $implicit: result }"></ng-template>
    </div>
    } @else {
    {{ result.label }}
    }
  </mat-option>
  }
</mat-autocomplete>

<div fxLayout="row" fxLayoutAlign="start center">
  <div>
    <mat-form-field
      [style.width.px]="width"
      [floatLabel]="disableLabelFloat ? 'never' : 'auto'"
      [hidden]="searchInput.disabled"
    >
      <input
        type="text"
        [placeholder]="placeholderText"
        aria-label="Search"
        matInput
        [matTooltip]="tooltip"
        [formControl]="searchInput"
        [matAutocomplete]="auto"
        #autocompleteInput
      />
      @if (!hideSearchIcon) {
      <button matPrefix mat-icon-button>
        <mat-icon>search</mat-icon>
      </button>
      }
    </mat-form-field>
    @if (error && !suppressError) {
    <mat-error [@inOutAnimation]>
      {{ error }}
    </mat-error>
    }
  </div>
  <div>
    <mat-spinner
      class="loading-indicator"
      color="primary"
      diameter="18"
      [attr.aria-busy]="isLoading"
      [ngClass]="{ 'loading-indicator--display': isLoading }"
    >
    </mat-spinner>
  </div>
</div>
